import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showUserDetail } from '../redux/slicers/userSlice';
import UserDetail from '../components/users/UserDetail';
import { Button } from 'react-bootstrap';
import Loading from "../components/Loading";

const UserDetailScreen = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            setLoading(true); 
            dispatch(showUserDetail(parseInt(id)));
        }
    }, [id, dispatch]);

    useEffect(() => {
        if (id) {
            setLoading(false);
        }
    }, [id]);

    const handleBack = () => {
        navigate('/arsitek');
    };

    return (
        <div className="container mt-4 mb-5">
            <div className="mb-3">
                <button className='btn btn-default' onClick={handleBack}>
                    ← Kembali ke list arsitek
                </button>
            </div>

            {loading ? (
                <Loading /> 
            ) : (
                <UserDetail />
            )}
        </div>
    );
};

export default UserDetailScreen;
